<template>
  <div :class="{ 'page-header': true, 'page-header--with-tabs': orderedTabs.length > 0, 'page-header--without-tabs': orderedTabs.length === 0 }">
    <div class="container">
      <div
        v-if="!!title"
        class="row"
      >
        <div class="gr-12">
          <h1>{{ title }}</h1>
        </div>
      </div>
      <div v-if="orderedTabs.length" class="row page-header__tabs">
        <div class="gr-12">
          <ul class="tabs">
            <li
              v-for="(tab, index) in orderedTabs"
              :key="tab.key"
              :class="{ active: tab.key === active, first: index === 0 }"
              @click="changeTab(tab)"
            >
              {{ tab.label }}
              <div v-if="tab.pin > 0" class="pin">
                {{ number(tab.pin) }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { number } from '@elements/number-formatter';

export default {
  name: 'PageHeader',
  components: {},
  props: {
    title: { type: String, default: '' },
    /**
     * [
     *  { key: "z", pin: 21, state: "Publiées"},
     *  { key: "b", pin: 3, label: "En modération"},
     *  { key: "a", pin: 43, label: "Désactivées"},
     * ]
     */
    tabs: { type: Array, default: () => [] },
    active: { type: String, default: '' },
    /**
     * {
     * 'a' => 1,
     * 'b' => 2,
     * 'c' => 3
     * }
     */
    order: { type: Object, default: () => {} },
  },
  computed: {
    orderedTabs() {
      if (!this.order) {
        return this.tabs;
      }

      let { tabs } = this;
      tabs = tabs.map((item) => {
        const tab = { ...item };
        tab.order = this.order[tab.key];
        return tab;
      });

      return tabs.sort((a, b) => {
        if (a.order > b.order) return 1;
        if (a.order < b.order) return -1;
        return 0;
      });
    },
  },
  methods: {
    changeTab(tab) {
      this.$emit('change-tab', tab);
    },
    number,
  },
};
</script>
